import React from "react";

function Home() {
  return <h1>Welcome to the Budgeting App</h1>;
}

export default Home;
